<template>
  <v-card class="d-flex flex-column align-center pa-6">
    <SadGuy />
    <TextBody v-if="!pushBlocked" class="mt-8" :font-size="0.875">
      <strong>{{ t$(".no_support.header") }}</strong>
      <br />
      <br />
      {{ t$(".no_support.description") }}
    </TextBody>
    <TextBody v-else class="mt-8" :font-size="0.875">
      <strong>{{ t$(".blocked.header") }}</strong>
      <br />
      <br />
      {{ t$(".blocked.description") }}
    </TextBody>
    <Button @click="$emit('close')" class="mt-6" :block="true"
      >Verstanden</Button
    >
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import SadGuy from "./assets/SadGuy.svg"
import TextBody from "components/UI/TextBody.vue"
import Button from "components/UI/Button.vue"
import useTranslate from "features/common/translate/concerns/useTranslate"

export default defineComponent({
  name: "PushUnsupportedWizard",
  components: {
    SadGuy,
    TextBody,
    Button,
  },
  props: {
    pushBlocked: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const { t$ } = useTranslate("components.push_wizard.unsupported_wizard")
    return {
      t$,
    }
  },
})
</script>
